import { configureStore, combineReducers } from "@reduxjs/toolkit";
import profileReducer from "./slices/profileSlice";

const rootReducer = combineReducers({
  profile: profileReducer
});

const store = configureStore({
  reducer: rootReducer
});

export default store;